/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCopiedProjectFieldDto } from '../../models/backend-copied-project-field-dto';
import { BackendCopiedProjectFieldRequestDto } from '../../models/backend-copied-project-field-request-dto';

export interface ProjectsCopiedProjectUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendCopiedProjectFieldRequestDto;
}

export function projectsCopiedProjectUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsCopiedProjectUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsCopiedProjectUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCopiedProjectFieldDto>;
    }),
  );
}

projectsCopiedProjectUpdate$XWwwFormUrlencoded.PATH = '/api/projects/copied_project/{id}/';
